// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-item-module--wrapper--61e44","level1":"nav-item-module--level1--b07a7","level2":"nav-item-module--level2--156cf","active":"nav-item-module--active--9edef"};